export const stageSlideDelay = 8000
export const stageTransitionDuration = 1100

export function stageLoopIndex(index: number, count: number) {
  return ((index % count) + count) % count
}

export function stageCanPlay(state: {
  playing: boolean; visible: boolean; pageVisible: boolean; expanded: boolean
  reducedMotion: boolean; interacting: boolean; keyboardFocused: boolean
  ready: boolean; pending: boolean
}) {
  return state.playing && state.visible && state.pageVisible && !state.expanded
    && !state.reducedMotion && !state.interacting && !state.keyboardFocused
    && state.ready && !state.pending
}

export function scheduleStageAdvance(advance: () => void) {
  const timer = setTimeout(advance, stageSlideDelay)
  return () => clearTimeout(timer)
}
